// we don't care about this rule in hook utils files
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'

export function useOnMount(effect: () => void | (() => void)) {
  // On mount, call the effect
  useEffect(effect, [])
}
